<template>
  <div class="chestnut">
    <section class="main">
         <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/chestnut/banner3.jpg" alt />
      </div>
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>关于粒上皇</el-breadcrumb-item>
          <el-breadcrumb-item>栗子文化</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="flex c_item">
        <div class="left">
          <div class="top_title">
            <div class="title1">
              CHESTNUT
              <br />CULTURE
            </div>
            <div class="title2">粒上皇的板栗为什么尤其好吃？</div>
          </div>
          <div class="nline"></div>
          <p style="text-indent: 0;font-weight: 600;margin:0;">千年栗史 燕山孕育</p>
          <p class="margin40">我国板栗种植史可追溯至三千多年前的西周，《诗经·鄘风·定之方中》《战国策》《左传》等古籍中均有记载。粒上皇甄选燕山山脉核心产区板栗，此地昼夜温差适宜、日照充沛、水土肥沃，得天独厚的自然条件孕育出优质栗果，被誉为“优质板栗的核心优势产区”¹，为品牌产品奠定了坚实的品质基底。</p>
          <p style="text-indent: 0;font-weight: 600;margin:0;">源头好料 极速锁鲜</p>
          <p>粒上皇坚守产地直采模式。每年采收季，品牌创始人潘俊海先生亲自带队深入河北燕山山脉腹地，团队通过“人工+技术”双重手段，严格剔除虫眼、霉烂、干瘪等瑕疵果实。鲜果离枝后，36小时内²高效衔接“采购-质检-冷链运输-入仓”全流程，经由双重筛查与全程冷链锁鲜，最大程度保留板栗的山林本味。</p>
		  <p style="text-indent: 0;font-weight: 600;margin:0;">全链把控 品质严控</p>
		  <p>依托二十余年行业深耕，粒上皇构建了从源头到终端的全产业链品质管控体系，始终秉持“颗颗精选，粒粒上品”的质量方针。品牌自建恒温仓储与全域冷链网络，将板栗存储温度精准控制在±3℃，全程稳定锁住板栗风味，切实保障全国门店板栗出品兼具高标准与安全品质。</p>

		</div>
        <div class="right">
          <img class="company_pic" src="../assets/img/chestnut/photo1.jpg" alt />
        </div>
      </div>
      <div class="flex c_item2">
        <div class="left">
          <img class="culture_pic" src="../assets/img/chestnut/photo2.jpg" alt />
        </div>
        <div class="right">
          <p style="text-indent: 0;font-weight: 600;margin:0;">匠心现炒 才更好吃</p>
          <p>粒上皇坚持每日新鲜现炒，传承“麦芽糖+黑砂”古法工艺，创新采用闭口炒制技术，减少水分流失，激发栗仁本味。炒制中辅以微量麦芽糖，旨在促进栗壳均匀受热、色泽油润，并形成极薄保护层，减少黑砂附着。每锅板栗出锅前，须经“看、摸、摇、剥、瞅、捏、尝”七重人工质检工序，力求颗颗外壳油亮、果仁饱满、香甜软糯。</p>
          <p style="text-indent: 0;font-weight: 600;margin:0;">国民好栗 深入人心</p>
          <p>深耕行业二十余载，粒上皇现炒板栗凭借出众口感与稳定品质，赢得了亿万消费者的口碑认可与海量复购。其软糯清甜、易剥洁净的独特美味体验，已成为众多食客的心头好。目前，品牌全国门店已超1600家，构建起全域连锁网络。凭借硬核的市场表现，粒上皇于2026年6月荣获艾媒咨询认证“中国现炒板栗销量第一品牌”（基于中国现炒板栗市场研究比对的结果确认，以2025年1月1日-2025年12月31日现炒板栗品牌全渠道销量(kg)占比排名统计），矢志打造国民心中值得信赖的板栗品类标杆。</p>
          <p style="font-size: 12px;text-indent: 0;color: #999;">注释：<br/>1.依据《地理标志产品 迁西板栗》GB/T 22744—2008 国家标准、新华社板栗产业官方报道、迁西县人民政府产业介绍官方报道整理。<br/>2.粒上皇内部供应链实测测算数据。<br/>3.门店数据截止至2025年12月统计数据。</p>
        </div>
      </div>
     <!-- <div class="article">
        <h3>栗与姓氏：</h3>
        <p
          class="margin20"
        >按《风俗通义》记载，栗姓出自华夏最古老姓氏之一的栗陆氏，是伏羲后人。栗陆氏是传说中上古帝王名，居住在北方，擅长种植栗树，以栗树为其氏族的神树，逐渐演化为氏族的原始图腾，并以此为氏族名和族徽，最终出现栗姓。历史上的栗姓名人有：燕国名将栗腹；汉景帝太子刘荣生母栗姬、汉代官吏栗融；明代进士栗在庭、栗铭、栗魁同；清代道光治河专家、林则徐好友栗毓美等。现在全国栗姓人口约30万，主要分布于河南、河北、山西、安徽、陕西等地。</p>
        <h3>栗字起源：</h3>
        <p
          class="margin20"
        >在远古时代，栗子是人类生存的重要食物，《庄子·盗跖》中记载：“古者禽兽多而人少，于是民皆巢居以避之，昼食橡栗，暮栖木上，故名之曰有巢氏。”中国最早的文字甲骨文中就有“栗”字，像一株结了果实的栗树。考古工作者发现，早在距今9000年前河南裴李岗遗址，以及7000年前的浙江河姆渡和西安半坡村遗址，都曾有板栗果实的遗物，还发现距今3600年前用来冶炼和烧制陶器的栗炭。</p>
        <h3>栗与风俗：</h3>
        <p
          class="margin20"
        >板栗与人类生产生活息息相关，逐渐形成了许多与板栗相关的风俗习惯。现在，许多地方仍保存着祭拜栗树、栗神的习俗，板栗也作为拜祭神仙或先人的祭品。在传统节日中，也不乏板栗的身影，“腊八粥”、“端午粽”、“重阳糕”传统美食无不以板栗为原料。</p>
        <h3>佳果珍馐</h3>
        <p
          class="margin20"
        >板栗营养价值极高，古时多被要求纳贡。即使在民间，晚辈早间拜见长辈，必须敬献枣栗，“取其早自谨敬”之意。《礼记》载：“子事父母，妇事舅姑，枣栗饴蜜以甘之”。而我国关于婚礼的最早书籍《仪礼•士昏礼》中更有详细记载：“质明，赞见妇于舅姑……妇执笲枣栗，自门入，升自西阶进拜，奠于席。”意思是，新媳妇于婚礼第二日见公婆必须用竹器盛满枣栗，跪拜请安，寓早起而虔敬之意。</p>
        <h3>祭祀神品</h3>
        <p>栗树在古代曾被我国许多民族供奉于神坛祭拜，视为祭天神树。古代先民祭祀社稷时，“夏后氏用松，殷人用柏，周人用栗”。因为练祭所立的神主用栗木做成，故称“栗主”，后通称宗庙神主为“栗主”。《公羊传•文公二年》就有“虞主用桑，练主用栗”的记载。从古至今，无论天子百官还是平头百姓，每有礼制都用板栗作为祭品。据《帝京景物略》记载：明代北京人用黍糕、枣栗等祭祀灶君，以期“上天言好事，下界保平安”。直到现在，我国的纳西族、彝族、哈尼族仍有祭拜栗树的习俗。此外，早在汉代就有人以栗木为棺，至今许多栗产区丧葬习俗中，仍以使用栗木棺材为荣。</p>

        <h3>行道树木</h3>
        <p
          class="margin20"
        >栗树还是古时候宫殿建设和道路绿化的重要树种。《诗经•国风•鄘风·定之方中》有“树之榛栗，椅桐梓漆，爱伐琴桑”的诗句，指卫文公在楚丘营造宫殿的时候，专门栽种了榛树和栗树。《诗经》有云：“栗在东门之外，不在园圃之间，则行道树也”，《左传》也有“行栗，表道树也”的记载，说明早在西周时期，栗树就已作为行道树使用。</p>
        <img src="../assets/img/chestnut/photo3.jpg" alt />
        <h3>栗与外交</h3>
        <p
          class="margin20 no_indent"
        >1959年，敬爱的周总理促成对日“关怀物资”贸易，也成为板栗出口历史上的一段佳话。以前，中日板栗贸易一直以民间往来形式存在。1954年，日本的栗子业者陆续加入日中贸易促进会等友好团体，发展中日贸易。但1958年，在日本长崎中国邮票和剪纸展览会上发生撕毁中国国旗的“长崎事件”，导致中日贸易全面中断。1959年初，当时的日本工会总评事务局长岩井章访华。在香港收购中国板栗的柴源一郎等人，连夜托付岩井章向周总理转达日本民间中小栗子业者需要救济的请求。周恩来总理体察日本中小企业者生活的困苦，提出了把板栗、生漆作为“关怀物资”的出口供给政策，这就是历史上有名的日中贸易三原则之一的“友好关怀物资”贸易。1959年5月，中华全国总工会邀请日本栗子业界访华。柴源一郎和矶贝博代表日本栗子业界经香港进入中国广州与廖承志谈判，最终以每吨104,000日元的价格，实现了迁西板栗的再次出口，数量是100吨。从此迁西板栗成为了中日民间友好贸易的象征商品，日本板栗经营商多年从事中日友好活动，还曾在板栗包装制品上印刷“中日友好”等宣传标语。</p>
        <p class="no_indent">中日建交后，1973年，日本栗子业界访华团就来迁西参观访问，此后每年都有多次互相的交流活动，促进了中日民间交往。</p>
        <h3>栗与诗画</h3>
          <p class="no_indent">中国五千年文明史中始终有板栗相随，历代文人墨客关于板栗的诗歌绘画作品不胜枚举。《诗经》自不必说，从汉代起，就有蔡邕的《伤故栗赋》，从南北朝到唐宋均有与板栗相关诗词存世，其中不乏杜甫、白居易、张籍、范成大、苏辙、陆游等大家，康熙皇帝更是亲自作诗《炒栗》，向世人介绍了炒栗的妙诀在于掌握火候。近现代大文豪郭沫若也曾作《采栗谣》。
          </p>
          <p class="no_indent">书画史上不仅有清代的“鹰栗图”、“秋晓翠羽图”，齐白石大师也曾专门以板栗作画。此外，还曾有“栗玉砚”一说，宋代大书法家米芾极为推崇，在《砚史•成州栗玉砚》记载：“栗玉砚，理坚，色如栗，不甚着墨，为器甚佳”。
          </p>
          <p class="no_indent">汉代蔡邕《伤故栗赋》：树遐方之嘉木兮，于灵宇之前庭；通二门以征行兮，夹阶除而列生。弥霜雪之不凋兮，当春夏而滋荣；因本心以诞节兮，挺青蘖之绿英。形猗猗以艳茂兮，似碧玉之精明。
          </p>
          <p class="no_indent">
          南北朝陆琼《栗赋》：四时逸盛，百果玄芳；绿梅春馥，红桃夏香。何群品之浮脆，惟此质之久长；外刺同夫枳棘，内洁甚于冰霜。伏南安而来清，列御宿而悬房；荐羞则 列，加笾则菱芡同行。金盘兮丽色，玉俎兮鲜光；周人以之战惧，大官称于柏梁。
          </p>
          <p class="no_indent">
          南北朝陆玠《赋得杂言咏栗诗》：货见珍于有汉，木取贵于隆周；英肇萌于朱夏，实方落 于素秋。委玉盘，杂椒糈；将象席，糅珍羞。<br/>
          唐代杜甫：“羞逐长安社中儿，赤鸡白狗睹梨栗”。 “入村樵径引，尝果栗皱开。”“山家蒸栗暖，野饭谢麋新。”<br/>
          唐代白居易《登村东古冢》：“村人不爱花，多种栗与枣；自来此村住，不觉风光好”，<br/>
          唐代张籍《山禽》：“山禽毛如白练带，栖我庭前栗树枝；猕猴半夜来取栗，一双中林向月飞”。<br/>
          宋代范成大《 良乡》：“ 新寒冻指似排签, 村酒虽酸未可嫌。 紫烂山梨红皱枣, 总输易栗十分甜”。<br/>
          宋代陆游：“齿根浮动叹吾衰，山栗炮燔疗夜饥。”“林深栗鼠健，屋老瓦松长。”<br/>
          明代刘基“墙角虫号瓜蔓索，树头禽吓栗房开。”<br/>
          清代蒲松龄在聊斋志异《促织》：上于盆而养之,蟹白栗黄,备极护爱,留待限期,以塞官责。<br/>
          郭沫若《采栗谣》：“上山采栗，栗熟茨深。栗刺手指，茨刺足心。一滴一粒，血染刺针。下山数栗，栗不盈斗；欲食不可，秋风怒吼。儿尚无衣，安能顾口！衣不厌暖，食不厌甘。富也食栗，犹嫌肉单。焉知贫贱，血以御寒？”
        </p>
        <img src="../assets/img/chestnut/photo4.jpg" alt />

        <h3>栗与典籍</h3>
        <p
          class="margin20 no_indent"
        >板栗有“千果之王”的美誉，与桃、杏、李、枣并称“五果”，中国古代典籍中多有论述。翻开古老的《诗经》，早有“树之榛栗”、“东门之栗”、“隰有栗”等记载。《战国策》记载，苏秦游说燕文侯时说： “燕国……南有碑石雁门之饶，北有枣栗之利，民虽不田作而足于枣栗矣。此所谓天府者也。”汉代的《史记•货殖列传》中说：“燕秦千树栗……此其人皆千户侯等。”《前汉•地理志》中记载，在沛郡还有一个县叫“栗县”。</p>
        <p class="no_indent">三国时期吴郡人陆玑在其著作《毛诗草木鸟兽虫鱼疏》中说“栗，五方皆有，惟渔阳范阳生者甜美味长，他方不及也。” 郦元注《水经》曰：汝南湾中，有地数顷，上有栗山，味不并南安之实也。燕岁贡四百石，以充天府。《金史•地理志》记载“蓟州产栗，今山中所树落实颇丰。”《齐民要术》、《周礼》、《礼仪》、《山海经》、《农桑辑要》等文献中，都有关于栗的记载。《齐民要术》专门用一个章节论述板栗栽培、收藏、加工方法。</p>
        <h3>食疗保健</h3>
          <p class="no_indent">板板栗有重要的食疗保健作用，花叶果实均可入药。《本草纲目》等历代医书均有记载。苏东坡的弟弟苏辙曾作诗《服栗》称赞其疗效，诗云：“老去日添腰脚病，山翁服栗旧传方。经霜斧刃全金气，插手丹田借火光。入口锵鸣初未熟，低头咀噍不容忙。客来为说晨兴晚，三咽徐收白玉桨。”
          </p>
          <p class="no_indent">栗花。性味微温、微苦、涩，有健脾止泄、散结消肿之功，适用于泻痢、便血、瘰疬等。此外，还能根治疝气。《日用本草》言其“治瘰疬。”《滇南本草》言其“治日久赤白痢疾，大肠下血。”《四川中药志》言其“治小儿消化不良及腹泻不止。”
          </p>
          <p class="no_indent">栗叶。鲜叶外用可治皮肤炎症。《滇南本草》言其“治喉疔火毒，煎服(二至三钱)。”《现代实用中药》言其“为收敛剂。外用涂漆疮。”
          </p>
          <p class="no_indent">栗壳。《食物本草》言其“煮汁饮之，止反胃消渴。”《日华子本草》言其“治泻血。”《太平圣惠方》言其“治鼻衄累医不止：栗壳五两，烧灰，研为末。每服二钱，以粥饮调服。”
          </p>
          <p class="no_indent">栗涩皮（栗内薄皮）。《食物本草》言其“治栗子颈(瘰疬)：栗蓬内膈断薄衣(栗)，捣敷之。”《本草纲目》言其“治骨鲠在咽：栗子内薄皮(栗)烧存性，研末，吹入咽中。”
          </p>
          <p class="no_indent">栗蓬(栗的总苞)。《唐本草》言其“疗丹火疮、毒肿。”《滇南本草》言其“烧灰吹鼻中，治中风不语。” 《广东中药》言其“治小儿百日咳：风栗壳三钱，加糖冬瓜五钱煎服。”
          </p>
          <p class="no_indent">栗果。性味甘寒，有“益气补脾、厚肠胃、补肾强筋，活血止血”的作用。唐代孙思邈说：“栗，肾之果也，肾病宜食之。”《本草纲目》中记载：“栗治肾虚，腰腿无力，能通肾益气，厚肠胃也。”栗树根。《食物本草》言其“治偏肾(疝)气，酒煎服之。”《四川中药志》言其“治血痹。”
          </p>
        <h3>民间板栗验方：</h3>
        <p class="no_indent">
          每日早晚各生食一至二枚，可治老年肾亏，小便弱频。<br/>
          生栗捣烂如泥，敷于患处，可治跌打损伤，筋骨肿痛；有止痛止血，吸收脓毒的作用。<br/>
          风干的栗子壳烧成炭再碾成粉状，加蜂蜜调和后用水冲服可治内痔出血。<br/>
          栗子壳与夏枯草、丹参复配治疗急性颈淋巴结炎和甲状腺肿大。<br/>
        </p>
        <h3>栗与美食</h3>
        <p>板栗有蒸、煮、炒等多种食用方法，以栗赈灾、蒸栗代粮的故事流传甚广。民间传说有大户人家把板栗粉碎后脱坯垒墙，以备饥荒年代度日。现在，栗子除了传统的糖炒栗子、风干栗子等吃法以外，还可以做成即食板栗仁、板栗粉、板栗果脯、栗子糕、栗子羹、栗子窝头等休闲食品。板栗更是“腊八粥”“端午粽”“重阳糕”“栗蓉月饼”中不可缺少的原料。此外，与栗相关的各种菜肴达200多种，如栗子鸡、板栗红烧肉、板栗烧菜心等，深受人们喜爱。</p>
      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.chestnut {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .c_item {
    width: 1000px;
    margin: 0 auto;
    padding: 80px 0 50px;
    text-align: left;
    align-items: center;
    > div {
      flex: 1;
    }
    .left {
      width: 472px;
      margin-right: 80px;
      .nline {
        height: 3px;
        background: #ffe800;
        margin: 68px 0 35px 0;
      }
      .top_title {
        position: relative;
        text-align: left;
        margin-bottom: 53px;
      }

      .top_title .title1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: 'HarmonyOS Sans SC';
        font-size: 60px;
        color: rgba(76, 1, 4, 0.05);
        line-height: 60px;
        text-align: left;
        font-weight: 400;
        margin-bottom: 6px;
      }

      .top_title .title2 {
        font-family: 'HarmonyOS Sans SC';
        font-size: 40px;
        color: #4c0104;
        text-align: left;
        font-weight: 500;
        width: 100%;
        margin-bottom: 13px;
        padding-top: 32px;
        position: relative;
        z-index: 1;
      }
      p {
        font-family: 'HarmonyOS Sans SC';
        font-size: 14px;
        color: black;
        letter-spacing: 0;
        line-height: 30px;
		    text-indent: 30px;
        margin-bottom: 15px;
        text-align: justify;
        text-align-last: left;
      }
      .margin40 {
          margin-bottom: 18px;
		  text-indent: 30px;
        }
    }
    .right {
      .company_pic {
        width: 448px;
        border-radius: 10px;
      }
    }
  }
  .c_item2 {
    width: 1000px;
    margin: 0 auto;
    padding: 0 0 73px;
    text-align: left;
    align-items: center;
    .right {
      flex: 1;
      p {
        font-family: 'HarmonyOS Sans SC';
        font-size: 14px;
        color: black;
        letter-spacing: 0;
        line-height: 30px;
        text-indent: 30px;
		    margin-bottom: 18px;
        text-align: justify;
        text-align-last: left;
      }
    }
    .left {
      width: 446px;
      margin-right: 80px;
      .culture_pic {
        width: 446px;
        border-radius: 10px;
      }
    }
  }
  .article {
    width: 1000px;
    margin: 0 auto;
    text-align: left;
    h1 {
      font-family: PingFangSC-Regular;
      font-size: 44px;
      color: #333333;
      padding: 52px 0;
    }
    > img {
      width: 100%;
      margin-bottom: 40px;
      border-radius: 8px;
    }
    h3 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 18px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 12px;
    }
    p {
      font-family: 'HarmonyOS Sans SC';
      font-size: 14px;
      color: black;
      line-height: 30px;
      margin-bottom: 30px;
      text-indent: 30px;
    }
    .no_indent{
        text-indent: 0px;
    }
    .margin20 {
      margin-bottom: 20px;
    }
    .imgbox {
      justify-content: space-between;
      img {
        width: 485px;
        height: 324px;
        border-radius: 8px;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
<style lang="scss">
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
</style>
